import { jsx as t } from "react/jsx-runtime";
import { twMerge as u } from "tailwind-merge";
const l = ({
  as: e = "a",
  href: a,
  isFetching: r,
  className: n,
  children: i,
  buttonTextClassName: o,
  ...d
}) => d["aria-disabled"] || r ? /* @__PURE__ */ t("button", { className: n, disabled: !!d["aria-disabled"], children: /* @__PURE__ */ t(p, { buttonTextClassName: o, isFetching: r, children: i }) }) : /* @__PURE__ */ t(e, { className: n, href: a, ...d, children: /* @__PURE__ */ t(p, { buttonTextClassName: o, isFetching: r, children: i }) }), p = ({
  children: e,
  isFetching: a,
  buttonTextClassName: r
}) => /* @__PURE__ */ t(
  "div",
  {
    className: u(
      "flex items-center justify-center gap-2 truncate",
      a && "opacity-0",
      r
    ),
    children: e
  }
);
export {
  p as ButtonInnerWrapper,
  l as default
};
